import React, { useState, useEffect } from "react";
import {
  Container,
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Box,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import ReportingTable from "./ReportingTable";
import "./CommonDashboard.css";
import MyReportingForm from "./MyReportingForm";
import { useDispatch, useSelector } from "react-redux";
import TitleWithDropdown from "./TitleWithDropdown";
import { setReporting } from "../redux/slices/reportingSlice";
import { setEmmsHeaders } from "../redux/slices/emmsAuthSlice";
import { setCurrentEmms } from "../redux/slices/currentEmmsSlice";
import axios from "axios";
import image from "../logos/reporting.png";
export const ReportingDashboard = () => {
  const dispatch = useDispatch();
  const emms = useSelector((state) => state.emms);

  const [responseData, setResponseData] = useState([]);
  const headers = useSelector((state) => state.header);
  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(emms?.emms?.[0]?.id);

  function fetchData(value) {
    setIsLoading(true);
    let selectedEmms = emms?.emms?.find((element) => element.id === value);
    dispatch(setCurrentEmms(selectedEmms));

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));
      const requestBody = {
        path: "reporting",
        query: {},
        emmsId: value,
        body: {},
        requestType: "GET",
        headers: emmsheaders?.headers,
      };
      const api = localStorage.getItem("api");
      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          dispatch(setReporting(response.data));
          setResponseData(response.data);
          setErrors(false);
        })
        .catch((error) => {
          console.error(error);
          setErrors(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }

  useEffect(() => {
    fetchData(selectedOption);
  }, []);

  const handleOptionChange = (event) => {
    setSelectedOption(event?.target?.value);
    fetchData(event?.target?.value);
  };

  const options = emms?.emms?.map((emm) => ({
    label: emm.name,
    value: emm.id,
  }));

  const reporting = useSelector((state) => state.reporting);

  return (
    <>
      <div className="mainContainer">
        <header>
          <figure>
            <img className="img" src={image} alt="Logo" />
          </figure>
        </header>
        <div className="title-container">
          <div className="title">
            <TitleWithDropdown
              title="EMMS Service"
              options={options}
              selectedOption={selectedOption}
              onOptionChange={handleOptionChange}
            />
          </div>
          <div>
            <MyReportingForm
              selectedOption={selectedOption}
              disabled={!!reporting.reporting}
            />
          </div>
        </div>
        <div style={{ marginLeft: "10%", marginTop: "2%" }}>
          <ReportingTable selectedOption={selectedOption} errors={errors} isLoading={isLoading} />
        </div>
      </div>
    </>
  );
};
